import * as THREE from 'three'
import { random } from 'lodash'

import alphaTexture from '../../assets/textures/stripes_gradient.jpg'
import globeTexture from '../../assets/textures/world.jpg'

var Shaders = {
  earth: {
    uniforms: {
      texture: { type: 't', value: null },
    },
    vertexShader: [
      'varying vec3 vNormal;',
      'varying vec2 vUv;',
      'void main() {',
      'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
      'vNormal = normalize( normalMatrix * normal );',
      'vUv = uv;',
      '}',
    ].join('\n'),
    fragmentShader: [
      'uniform sampler2D texture;',
      'varying vec3 vNormal;',
      'varying vec2 vUv;',
      'void main() {',
      'vec3 diffuse = texture2D( texture, vUv ).xyz;',
      'float intensity = 1.05 - dot( vNormal, vec3( 0.0, 0.0, 1.0 ) );',
      'vec3 atmosphere = vec3( 1.0, 1.0, 1.0 ) * pow( intensity, 6.0 );',
      'gl_FragColor = vec4( diffuse + atmosphere, 1.0 );',
      '}',
    ].join('\n'),
  },
  atmosphere: {
    uniforms: {},
    vertexShader: [
      'varying vec3 vNormal;',
      'void main() {',
      'vNormal = normalize( normalMatrix * normal );',
      'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
      '}',
    ].join('\n'),
    fragmentShader: [
      'varying vec3 vNormal;',
      'void main() {',
      'float intensity = pow( 0.8 - dot( vNormal, vec3( 0, 0, 1.0 ) ), 6.0 );',
      'gl_FragColor = vec4( 0.0, 0.0, 0.0, 0.10 ) * intensity;',
      '}',
    ].join('\n'),
  },
}

export default (scene, data, visitordata) => {
  var shader, uniforms, material, mesh, geometry, point, baseGeometry, points

  const group = new THREE.Group()

  // Globe
  const subjectGeometry = new THREE.SphereGeometry(200, 40, 30)
  shader = Shaders['earth']
  uniforms = THREE.UniformsUtils.clone(shader.uniforms)
  uniforms['texture'].value = THREE.ImageUtils.loadTexture(globeTexture)
  const subjectMaterial = new THREE.ShaderMaterial({
    uniforms: uniforms,
    vertexShader: shader.vertexShader,
    fragmentShader: shader.fragmentShader,
  })
  const subjectMesh = new THREE.Mesh(subjectGeometry, subjectMaterial)
  subjectMesh.rotation.y = Math.PI
  group.add(subjectMesh)

  // Shadow
  shader = Shaders['atmosphere']
  uniforms = THREE.UniformsUtils.clone(shader.uniforms)
  material = new THREE.ShaderMaterial({
    uniforms: uniforms,
    vertexShader: shader.vertexShader,
    fragmentShader: shader.fragmentShader,
    side: THREE.BackSide,
    blending: THREE.AdditiveBlending,
    transparent: true,
  })
  mesh = new THREE.Mesh(subjectGeometry, material)
  mesh.scale.set(1.2, 1.2, 1.2)
  group.add(mesh)

  // Points
  geometry = new THREE.CylinderGeometry(1, 1, 1, 32)
  geometry.applyMatrix(new THREE.Matrix4().makeTranslation(0, 0, -0.5))
  point = new THREE.Mesh(geometry)

  var subgeo = new THREE.Geometry()
  function addData(data, opts) {
    var lat, lng, size, color, i, step
    console.log()
    var c =
      opts.color === 'blue'
        ? new THREE.Color(0x039be5)
        : new THREE.Color(0x219653)
    step = 3

    for (i = 0; i < data.length; i += step) {
      lat = data[i]
      lng = data[i + 1]
      color = c
      size = data[i + 2]
      size = size * 1
      addPoint(lat, lng, size, color, subgeo)
    }
    baseGeometry = subgeo
  }

  function createPoints() {
    if (baseGeometry !== undefined) {
      points = new THREE.Mesh(
        baseGeometry,
        new THREE.MeshBasicMaterial({
          color: 0xffffff,
          vertexColors: THREE.FaceColors,
          morphTargets: true,
          transparent: true,
          opacity: 0.9,
        })
      )
    }
    group.add(points)
  }

  function addPoint(lat, lng, size, color, subgeo) {
    var phi = ((90 - lat) * Math.PI) / 180
    var theta = ((180 - lng) * Math.PI) / 180

    point.position.x = 200 * Math.sin(phi) * Math.cos(theta)
    point.position.y = 200 * Math.cos(phi)
    point.position.z = 200 * Math.sin(phi) * Math.sin(theta)

    point.lookAt(mesh.position)
    point.rotateX(Math.PI / 2)

    point.scale.y = Math.max(size, 0.1) // avoid non-invertible matrix
    point.updateMatrix()

    for (var i = 0; i < point.geometry.faces.length; i++) {
      point.geometry.faces[i].color = color
    }
    if (point.matrixAutoUpdate) {
      point.updateMatrix()
    }
    subgeo.merge(point.geometry, point.matrix)
  }

  // Add Points
  addData(data, { color: '#4BC169' })
  addData(visitordata, { color: 'blue' })

  createPoints()

  // Add to Scene
  group.rotateX(random(Math.PI))
  group.rotateY(random(Math.PI))
  group.rotateZ(random(Math.PI))

  scene.add(group)

  const speed = 0.05

  function update(time) {
    const angle = time * speed

    // const frequency = 0.01 // Frequency in Hz
    // const angleZ = 0.25 * (1 + Math.sin(2 * Math.PI * frequency * time))

    group.rotation.y = angle
    // group.rotation.z = angleZ
  }

  return {
    update,
  }
}



// WEBPACK FOOTER //
// ./src/components/threejs/SceneSubject.js